import { Link } from "react-router-dom";
import { VISTACION_URL, CONTACT, PARTNERS } from "@/constants";

const LINKS = [
  ["Aircraft For Sale", "/aircraft-for-sale"],
  ["Request a Flight", "/enquire/charter"],
  ["Empty Legs & Offers", "/empty-legs"],
  ["Yachts", "/yachts"],
  ["Bullion & Commodities", "/enquire/bullion"],
  ["Membership", "/#membership"],
  ["Jet Account", "/#jet-account"],
  ["About Us", "/#about"],
  ["Contact", "/#contact"],
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-obsidian border-t border-white/5 py-16">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <p className="font-serif text-2xl text-white">Aero Vista <span className="text-gold">Club</span></p>
          <p className="mt-3 text-sm text-white/50 font-light max-w-xs leading-relaxed">
            Private jet charter, aircraft sales, yachts and bullion — one discreet club for executive travel and luxury assets.
          </p>
          <div className="mt-6 space-y-2 text-sm text-white/60">
            <a href={CONTACT.phoneTel} className="block hover:text-gold transition-colors" data-testid="footer-phone-link">Call {CONTACT.phoneDisplay}</a>
            <a href={CONTACT.whatsappUrl} target="_blank" rel="noopener noreferrer" className="block hover:text-gold transition-colors" data-testid="footer-whatsapp-link">WhatsApp {CONTACT.whatsappDisplay}</a>
            <a href={`mailto:${CONTACT.email}`} className="block hover:text-gold transition-colors" data-testid="footer-email-link">{CONTACT.email}</a>
          </div>
        </div>
        <nav className="lg:col-span-5 grid grid-cols-2 gap-x-10 gap-y-3">
          {LINKS.map(([label, to]) => (
            <Link key={to} to={to} data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="text-xs uppercase tracking-[0.18em] text-white/50 transition-colors duration-300 hover:text-white">{label}</Link>
          ))}
          <a href={VISTACION_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-link-vistacoin"
             className="text-xs uppercase tracking-[0.18em] text-gold transition-colors duration-300 hover:text-gold-light">Vistacoin</a>
        </nav>
        <div className="lg:col-span-3">
          <p className="text-[10px] uppercase tracking-[0.25em] text-white/40 mb-4">Sourcing partners</p>
          <div className="space-y-3">
            {PARTNERS.map((p) => (
              <a key={p.name} href={p.url} target="_blank" rel="noopener noreferrer" data-testid={`footer-partner-${p.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                 className="block text-sm text-white/60 hover:text-gold transition-colors">{p.name} <span className="text-white/30 text-xs">· {p.role}</span></a>
            ))}
          </div>
        </div>
      </div>
      <div className="mt-14 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-4">
        <p className="text-[11px] text-white/30 tracking-wide">© {new Date().getFullYear()} Aero Vista Club. All rights reserved.</p>
        <div className="flex gap-6 text-[11px] text-white/30 tracking-wide">
          <span>aerovistaclub.co.uk</span>
          <Link to="/admin" className="hover:text-white/60 transition-colors" data-testid="footer-admin-link">Team login</Link>
        </div>
      </div>
    </div>
  </footer>
);
